/* eslint-disable max-len */
import { AllieIconProps } from '../../../components';

export const WarningIcon: React.FC<AllieIconProps> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
    <g clipPath="url(#clip0_2850_604)">
      <path
        d="M8.49982 6.49997V9.16664M8.49982 11.8333H8.50648M7.5767 3.09445L2.09344 12.5655C1.7893 13.0909 1.63723 13.3535 1.65971 13.5691C1.67931 13.7571 1.77783 13.928 1.93073 14.0392C2.10604 14.1666 2.40954 14.1666 3.01656 14.1666H13.9831C14.5901 14.1666 14.8936 14.1666 15.0689 14.0392C15.2218 13.928 15.3203 13.7571 15.3399 13.5691C15.3624 13.3535 15.2103 13.0909 14.9062 12.5655L9.42294 3.09445C9.11989 2.57101 8.96837 2.30929 8.77068 2.22139C8.59824 2.14471 8.40139 2.14471 8.22895 2.22139C8.03126 2.30929 7.87974 2.57101 7.5767 3.09445Z"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2850_604">
        <rect width="16" height="16" fill="white" transform="translate(0.5 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
